import OrderProvider  from './OrderContext';
import Order from './Order';
import { Page } from 'components';

let Index = () => {
    return (
        <OrderProvider>
            <Page title="Order">
                <Order />
            </Page>
        </OrderProvider>
    )
}

export default Index;